module.exports = __webpack_public_path__ + "static/media/sendToPrinter.4fcbfcbf.gif";